
import { VImg } from "vuetify/lib";

export default VImg.extend({});
